import { IEstablishmentAsCustomerData } from "../../../modules/invoice/application/dtos/IEstablishmentAsCustomerData";
import { IEmitInvoiceRequest } from "../../../modules/invoice/application/dtos/IInvoiceData";
import { IInvoiceService } from "../../../modules/invoice/domain/interfaces/IInvoiceService";
import { Api } from "../bases/Api";
import { IEmitirNfceRequest, INfceItemResponse, convertNfceToInvoice } from "./anticorruption/INfceResponse";


var api = Api();
const InvoiceService: () => IInvoiceService = () => {
    const EmitInvoice = async (invoice: IEmitInvoiceRequest) => {
        const anticorruptionRequest: IEmitirNfceRequest = {
            pedidoId: invoice.orderId,
            documento: invoice.document,
            ehManual: invoice.isManual
        }

        const response = await api.post<INfceItemResponse[]>('/v2/NFCe/Emitir', anticorruptionRequest);

        // const response = await SimulateNfceItemResponse();
        return convertNfceToInvoice(response.data)

    }

    const EstablishmentAsCustomer = async (localId: string, document: string) => {
        const response = await api.post<IEstablishmentAsCustomerData>('/ClienteEstabelecimento/Cnpj',
            { localId, cnpj: document },
            { headers: { disabledError: true } }
        );
        return response.data;
    }

    return ({ EmitInvoice, EstablishmentAsCustomer })
}
export default InvoiceService   
